if (process && process.env && process.env.NODE_ENV && (process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'dev')) {
  Mercadopago.setPublishableKey('APP_USR-947756cc-699e-4143-8956-16809f9c5b64')
  window.API = {
    overview: 'https://dashboard.duquetrainer.com/general',
    siteURL: 'https://app.duquetrainer.com.br/#',
    users: 'https://users.duquetrainer.com',
    userAddresses: 'https://user-addresses.duquetrainer.com',
    userTickets: 'https://user-tickets.duquetrainer.com',
    userTicketsAnswers: 'https://user-ticket-answers.duquetrainer.com',
    userNotes: 'https://user-notes.duquetrainer.com',
    userHealthyCards: 'https://user-healthy-cards.duquetrainer.com',
    userEvaluations: 'https://user-evaluations.duquetrainer.com/hmg',
    userEvaluationsPhotos: 'https://user-evaluation-photos.duquetrainer.com',
    userTrainings: 'https://trainings.duquetrainer.com',
    userExercises: 'https://exercises.duquetrainer.com',
    userTrainingExercises: 'https://training-exercises.duquetrainer.com',
    userAgenda: 'https://user-agenda.duquetrainer.com',
    notifications: 'https://notifications.duquetrainer.com',
    mpPayments: 'https://mp-payments.duquetrainer.com',
    mpCustomers: 'https://mp-customers.duquetrainer.com',
    mpCustomersCards: 'https://mp-customers-cards.duquetrainer.com',
    mpSubscriptions: 'https://mp-pre-approval.duquetrainer.com',
    mpPlans: 'https://mp-plans.duquetrainer.com',
    mpBalance: 'https://mp-admin.duquetrainer.com/balance',
    plans: {
      'TEST': '9629b8875aad4c76872596c8eb7b8894'
      // 'mensal': '5a938d2f793844b8b5acfec54399ec17',
      // 'trimestral': '7dff8800299d4f809b6e41cc0471ecf4',
      // 'semestral': 'f017742666384b8dab28da3f857f0540'
    }
  }
} else {
  window.API = {
    overview: 'https://dashboard.duquetrainer.com/general',
    siteURL: 'https://app.duquetrainer.com.br/#',
    users: 'https://users.duquetrainer.com',
    userAddresses: 'https://user-addresses.duquetrainer.com',
    userTickets: 'https://user-tickets.duquetrainer.com',
    userTicketsAnswers: 'https://user-ticket-answers.duquetrainer.com',
    userNotes: 'https://user-notes.duquetrainer.com',
    userHealthyCards: 'https://user-healthy-cards.duquetrainer.com',
    userEvaluations: 'https://user-evaluations.duquetrainer.com',
    userEvaluationsPhotos: 'https://user-evaluation-photos.duquetrainer.com',
    userTrainings: 'https://trainings.duquetrainer.com',
    userExercises: 'https://exercises.duquetrainer.com',
    userTrainingExercises: 'https://training-exercises.duquetrainer.com',
    userAgenda: 'https://user-agenda.duquetrainer.com',
    notifications: 'https://notifications.duquetrainer.com',
    mpPayments: 'https://mp-payments.duquetrainer.com',
    mpCustomers: 'https://mp-customers.duquetrainer.com',
    mpCustomersCards: 'https://mp-customers-cards.duquetrainer.com',
    mpSubscriptions: 'https://mp-pre-approval.duquetrainer.com',
    mpPlans: 'https://mp-plans.duquetrainer.com',
    mpBalance: 'https://mp-admin.duquetrainer.com/balance',
    plans: {
      'mensal': '5a938d2f793844b8b5acfec54399ec17',
      'trimestral': '7dff8800299d4f809b6e41cc0471ecf4',
      'semestral': 'f017742666384b8dab28da3f857f0540'
    }
  }
  Mercadopago.setPublishableKey('APP_USR-947756cc-699e-4143-8956-16809f9c5b64')
}



// WEBPACK FOOTER //
// ./src/api.js